import React from 'react';
import { twMerge } from 'tailwind-merge';

export function TabHeader({
  tabs,
  rightContent,
}: {
  tabs: {
    text: string;
    onClick: () => void;
    active: boolean;
  }[];
  rightContent?: React.ReactNode;
}) {
  return (
    <div className="mt-3 flex h-8 w-full items-start border-b border-neutral100 lg:h-10">
      <div className="flex h-full  flex-1 gap-5 lg:gap-8">
        {tabs.map(({ text, onClick, active }) => (
          <button
            key={`tab-${text}`}
            onClick={onClick}
            className={twMerge(
              `relative flex flex-00auto  cursor-pointer items-start align-top font-title text-title-m font-medium lg:text-title-l`,
              active ? `text-base800` : `text-neutral500`,
            )}
          >
            <span className="first-letter:uppercase">{text}</span>
            {active && <div className="absolute bottom-0 left-0 right-0 h-0.5 bg-base800" />}
          </button>
        ))}
      </div>
      {rightContent && <div className="flex flex-00auto items-start">{rightContent}</div>}
    </div>
  );
}
